module.exports = __webpack_public_path__ + "img/frosty-elion-9792b8.netlify.com_ (2).abf48ca2.png";